import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { UnifiedRoutingOwnerNames } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingOwnerNames';
import { useUnifiedRoutingExplainerMessage } from 'automation-ui-action-features/actions/rotate-object/hooks/useUnifiedRoutingExplainerMessage';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnifiedRoutingUsersAndTeamsExplainer = ({
  objectTypeId,
  routingRuleDefinition
}) => {
  const _useUnifiedRoutingExp = useUnifiedRoutingExplainerMessage(routingRuleDefinition),
    {
      type
    } = _useUnifiedRoutingExp,
    messageOptions = _objectWithoutPropertiesLoose(_useUnifiedRoutingExp, _excluded);
  if (type === '') {
    return null;
  }
  const elements = {
    ObjectTypeName,
    UnifiedRoutingOwnerNames
  };
  const options = Object.assign({}, messageOptions, {
    objectTypeId
  });
  if (type === 'users-only') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: elements,
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.users-only_jsx",
      options: options
    });
  }
  if (type === 'teams-only') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: elements,
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.teams-only_jsx",
      options: options
    });
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: elements,
    message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.users-and-teams_jsx",
    options: options
  });
};
UnifiedRoutingUsersAndTeamsExplainer.displayName = 'UnifiedRoutingUsersAndTeamsExplainer';